// extracted by mini-css-extract-plugin
export var active = "FlipCards-module--active--2a151";
export var back = "FlipCards-module--back--718d2";
export var card = "FlipCards-module--card--7340a";
export var container = "FlipCards-module--container--a3ffe";
export var front = "FlipCards-module--front--d7fa0";